import React, { createContext, useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../api';

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchProducts = useCallback(async (force = false) => {
        if (products.length > 0 && !force) return;

        setLoading(true);
        setError(null);
        try {
            const data = await apiFetch("/api/products/all");
            setProducts(data.data || []);
        } catch (err) {
            console.error("Failed to fetch products:", err);
            setError(err.message);
            setProducts([]);
        } finally {
            setLoading(false);
        }
    }, [products.length]);

    useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);

    return (
        <ProductContext.Provider value={{ products, loading, error, refreshProducts: () => fetchProducts(true) }}>
            {children}
        </ProductContext.Provider>
    );
};
